<!--- COMPONENTE PCPartidasActivasYRecientesLineaParaPaletizado  ---->
<!---
Descripción del componente:
---------------------------
- Incluye una lista con las partidas activas y las finalizadas recientemente de una linea de producción manteniendo un contador de los kilos volcados envasados y restantes.

Eventos del componente:
-----------------------
-  xxxxxxxxxxx ->
--->
<template>
  <div class="main-PCPartidasActivasYRecientesLineaParaPaletizado">
    <!-- Preloader de carga -->
    <UCPreload :show="mostrarPrecarga" />
    <!-- Registros de Partidas Activas -->
    <div class="div-registrosDePartidasActivas">
      <div
        v-for="penPV in partidasEnPuntoDeVolcado"
        :key="penPV.Id"
        @click="SeleccionPartida(penPV)"
      >
        <f7-row
          v-if="penPV.Activa"
          class="div-registroPartida seleccionable"
          :class="{ 'div-registroPartidaSeleccionada': penPV === seleccionPatidaEnPuntoDevolcado }"
        >
          <f7-col
            width="5"
            class="col-indicadorEstadoVolcado"
          >
            <span class="inidicador-amarillo-8" />
          </f7-col>
          <f7-col width="70">
            <f7-row class="no-padding">
              <f7-col width="100">
                <span class="span-texto-azulOscuro-18-500">
                  {{ FormatearCadena(penPV.Partida.Articulo.Familia.Nombre, 30) }}
                </span>
              </f7-col>
            </f7-row>
            <f7-row class="no-padding">
              <f7-col
                width="100"
                class="span-texto-grisAzul-14-400"
              >
                <!-- eslint-disable-next-line @intlify/vue-i18n/no-raw-text -->
                <span v-if="!penPV.EsPartidaDeEntrada && penPV.DatosOrigen != null && penPV.DatosOrigen.length > 1">
                  (+)
                </span>
                <span>
                  {{ `${penPV.Partida.Serie}/${FormatearIdentificadorPartida(penPV.Partida.Numero)}` }}
                </span>
                <span> {{ penPV.PuntoVolcado.DescripcionCorta }}</span>
                <span
                  v-if="usoLotesMovilidad && penPV.Lote != null"
                  class="span-texto-naranja-14-400"
                >
                  {{ `${$t('common.lot').toUpperCase()}:` }}
                </span>
                <span
                  v-if="usoLotesMovilidad && penPV.Lote != null"
                  class="span-texto-naranja-14-400"
                >{{ penPV.Lote.Codigo }}
                </span>
              </f7-col>
            </f7-row>
          </f7-col>
          <f7-col
            width="25"
            class="col-horaVolcadoPartida"
          >
            <div class="div-horaRegistroMovimiento azul">
              {{ FormatearFecha(penPV.FechaEstado) }}
            </div>
          </f7-col>

          <!-- Indicadores De Envasado -->
          <f7-row class="row-personalizaciones span-texto-grisAzul-14-400">
            <PCOperacionesPersonalizadas
              v-if="personalizacionComponentePartidasActiva"
              class="operaciones-personalizadas"
              :app-theme="appTheme"
              :tipo-entidad="1"
              componente-aplicacion="PCPartidasActivasYRecientesLineaParaPaletizado"
              :entidad="{ Id: penPV.Partida.Id }"
              formulario-padre="FrmPaletizadoMultiPunto"
              :modo-consulta-agrupada="true"
              :datos="datosPartidasParaPersonalizaciones"
              :mostrar-precarga="false"
            />
          </f7-row>
          <f7-row
            v-if="penPV === seleccionPatidaEnPuntoDevolcado"
            class="row-inidicadoresDeVolcadoEnvasado"
          >
            <f7-col width="33">
              <f7-row class="no-padding">
                <f7-col width="100">
                  <span class="span-texto-azulOscuro-24-500">{{ kilosVolcadosPartidaSeleccionada }}</span>
                </f7-col>
              </f7-row>
              <f7-row class="no-padding">
                <f7-col
                  width="100"
                  class="span-texto-azulOscuro-12-400"
                >
                  <span> {{ $t('KilosVol').toUpperCase() }}</span>
                </f7-col>
              </f7-row>
            </f7-col>
            <f7-col
              width="33"
              class="col-indicadorKilosEnvasados"
            >
              <f7-row class="no-padding">
                <f7-col width="100">
                  <span class="span-texto-azulOscuro-24-500">{{ kilosEnvasadosPartidaSeleccionada }}</span>
                </f7-col>
              </f7-row>
              <f7-row class="no-padding">
                <f7-col
                  width="100"
                  class="span-texto-azulOscuro-12-400"
                >
                  <span> {{ $t('KilosEnv').toUpperCase() }}</span>
                </f7-col>
              </f7-row>
            </f7-col>
            <f7-col
              width="33"
              class="col-indicadorKilosVolcados"
            >
              <f7-row class="no-padding">
                <f7-col width="100">
                  <span class="span-texto-amarilloNaranja-24-500">{{ kilosRestantesEnvasadoPartidaSeleccionada }}</span>
                </f7-col>
              </f7-row>
              <f7-row class="no-padding">
                <f7-col
                  width="100"
                  class="span-texto-azulOscuro-12-400"
                >
                  <span> {{ $t('KilosVol').toUpperCase() }}</span>
                </f7-col>
              </f7-row>
            </f7-col>
          </f7-row>
          <!-- FIN Indicadores De Envasado -->
        </f7-row>
      </div> <!-- Fin registro -->
    </div> <!-- Fin Registros Activos -->

    <!-- Registros de Partidas Finalizadas -->
    <div class="div-registrosDePartidasFinalizadas">
      <div
        v-for="penPV in partidasEnPuntoDeVolcado"
        :key="penPV.Id"
        @click="SeleccionPartida(penPV)"
      >
        <f7-row
          v-if="!penPV.Activa"
          class="div-registroPartida seleccionable"
          :class="{ 'div-registroPartidaSeleccionada': penPV === seleccionPatidaEnPuntoDevolcado }"
        >
          <f7-col
            width="5"
            class="col-indicadorEstadoVolcado"
          >
            <span class="inidicador-azul-8" />
          </f7-col>
          <f7-col width="70">
            <f7-row class="no-padding">
              <f7-col width="100">
                <span class="span-texto-azulOscuro-18-500">
                  {{ FormatearCadena(penPV.Partida.Articulo.Familia.Nombre, 30) }}
                </span>
              </f7-col>
            </f7-row>
            <f7-row class="no-padding">
              <f7-col width="100">
                <span class="span-texto-grisAzul-14-400">
                  {{ `${penPV.Partida.Serie}/${FormatearIdentificadorPartida(penPV.Partida.Numero)} → ${penPV.PuntoVolcado.DescripcionCorta}` }}
                </span>
                <span
                  v-if="usoLotesMovilidad && penPV.Lote != null"
                  class="span-texto-naranja-14-400"
                > {{ `${$t('common.lot').toUpperCase()}:` }} </span>
                <span
                  v-if="usoLotesMovilidad && penPV.Lote != null"
                  class="span-texto-naranja-14-400"
                >{{ penPV.Lote.Codigo }}
                </span>
              </f7-col>
            </f7-row>
          </f7-col>
          <f7-col
            width="25"
            class="col-horaVolcadoPartida"
          >
            <div class="div-horaRegistroMovimiento gris">
              {{ FormatearFecha(penPV.FechaEstado) }}
            </div>
          </f7-col>

          <!-- Indicadores De Envasado -->
          <f7-row
            v-if="penPV === seleccionPatidaEnPuntoDevolcado"
            class="row-inidicadoresDeVolcadoEnvasado"
          >
            <f7-col width="33">
              <f7-row class="no-padding">
                <f7-col width="100">
                  <span class="span-texto-azulOscuro-24-500">{{ kilosVolcadosPartidaSeleccionada }}</span>
                </f7-col>
              </f7-row>
              <f7-row class="no-padding">
                <f7-col
                  width="100"
                  class="span-texto-azulOscuro-12-400"
                >
                  <span> {{ $t('KilosVol').toUpperCase() }} </span>
                </f7-col>
              </f7-row>
            </f7-col>
            <f7-col
              width="33"
              class="col-indicadorKilosEnvasados"
            >
              <f7-row class="no-padding">
                <f7-col width="100">
                  <span class="span-texto-azulOscuro-24-500">{{ kilosEnvasadosPartidaSeleccionada }}</span>
                </f7-col>
              </f7-row>
              <f7-row class="no-padding">
                <f7-col
                  width="100"
                  class="span-texto-azulOscuro-12-400"
                >
                  <span> {{ $t('KilosEnv').toUpperCase() }} </span>
                </f7-col>
              </f7-row>
            </f7-col>
            <f7-col
              width="33"
              class="col-indicadorKilosVolcados"
            >
              <f7-row class="no-padding">
                <f7-col width="100">
                  <span class="span-texto-amarilloNaranja-24-500">{{ kilosRestantesEnvasadoPartidaSeleccionada }}</span>
                </f7-col>
              </f7-row>
              <f7-row class="no-padding">
                <f7-col
                  width="100"
                  class="span-texto-azulOscuro-12-400"
                >
                  <span> {{ $t('KilosVol').toUpperCase() }}</span>
                </f7-col>
              </f7-row>
            </f7-col>
          </f7-row>
          <!-- FIN Indicadores De Envasado -->
        </f7-row>
      </div> <!-- Fin registro -->
    </div> <!-- Fin Registros Partidas Finalizadas -->

    <!-- Popup Más Partidas Volcadas -->
    <f7-popup
      class="masPartidasVolcadas-popup"
      :opened="popupMasPartidasVolcadas"
      @popup:closed="CerrarMasPartidasVolcadas()"
    >
      <f7-navbar
        :title="$t('PartidasvolcadasEnLineaDeProduccion')"
        sliding
        :style="appTheme"
      >
        <f7-nav-right>
          <f7-link @click="CerrarMasPartidasVolcadas()">
            {{ $t('common.x') }}
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <UCPreload :show="mostrarPrecargaVerMas" />
      <div class="div-registrosDePartidasPopup">
        <!-- Registros de Partidas Activas -->
        <div class="div-registrosDePartidasActivas">
          <div
            v-for="penPV in listadoPartidasTotalesEnPuntoVolcado"
            :key="penPV.Id"
            @click="SeleccionPartida(penPV)"
          >
            <f7-row
              v-if="penPV.Activa"
              class="div-registroPartida"
            >
              <f7-col
                width="5"
                class="col-indicadorEstadoVolcado"
              >
                <span class="inidicador-amarillo-8" />
              </f7-col>
              <f7-col width="70">
                <f7-row class="no-padding">
                  <f7-col width="100">
                    <span class="span-texto-azulOscuro-18-500">{{ FormatearCadena(penPV.Partida.Articulo.Familia.Nombre, 30) }}</span>
                  </f7-col>
                </f7-row>
                <f7-row class="no-padding">
                  <f7-col
                    width="100"
                    class="span-texto-grisAzul-14-400"
                  >
                    <span>
                      {{ `${penPV.Partida.Serie}/${FormatearIdentificadorPartida(penPV.Partida.Numero)} → ${penPV.PuntoVolcado.DescripcionCorta}` }}
                    </span>
                  </f7-col>
                </f7-row>
              </f7-col>
              <f7-col
                width="25"
                class="col-horaVolcadoPartida"
              >
                <div class="div-horaRegistroMovimiento azul">
                  {{ FormatearFecha(penPV.FechaEstado) }}
                </div>
                <div class="span-texto-grisAzul-14-400">
                  {{ FormatearFecha2(penPV.FechaEstado) }}
                </div>
              </f7-col>
            </f7-row>
          </div> <!-- Fin registro -->
        </div> <!-- Fin Registros Activos -->

        <!-- Registros de Partidas Finalizadas -->
        <div class="div-registrosDePartidasFinalizadas">
          <div
            v-for="penPV in listadoPartidasTotalesEnPuntoVolcado"
            :key="penPV.Id"
            @click="SeleccionPartida(penPV)"
          >
            <f7-row
              v-if="!penPV.Activa"
              class="div-registroPartida"
            >
              <f7-col
                width="5"
                class="col-indicadorEstadoVolcado"
              >
                <span class="inidicador-azul-8" />
              </f7-col>
              <f7-col width="70">
                <f7-row class="no-padding">
                  <f7-col width="100">
                    <span class="span-texto-azulOscuro-18-500">{{ FormatearCadena(penPV.Partida.Articulo.Familia.Nombre, 30) }}</span>
                  </f7-col>
                </f7-row>
                <f7-row class="no-padding">
                  <f7-col width="100">
                    <span class="span-texto-grisAzul-14-400">
                      {{ `${penPV.Partida.Serie}/${FormatearIdentificadorPartida(penPV.Partida.Numero)} ${penPV.PuntoVolcado.DescripcionCorta}` }}
                    </span>
                  </f7-col>
                </f7-row>
              </f7-col>
              <f7-col
                width="25"
                class="col-horaVolcadoPartida"
              >
                <div class="div-horaRegistroMovimiento gris">
                  {{ FormatearFecha(penPV.FechaEstado) }}
                </div>
                <div class="span-texto-grisAzul-14-400">
                  {{ FormatearFecha2(penPV.FechaEstado) }}
                </div>
              </f7-col>
            </f7-row>
          </div> <!-- Fin registro -->
        </div> <!-- Fin Registros Partidas Finalizadas -->

        <div v-if="listadoPartidasTotalesEnPuntoVolcado != null && listadoPartidasTotalesEnPuntoVolcado.length > 5">
          <f7-button
            fill
            class="btn-color-gris-1 btn-tamaño-3 btn-cargarMasPartidas"
            @click="VerMasPartidasDeLaColaDeVolcado(cantidadRegistrosCargaVistaPopup + 50)"
          >
            {{ $t('common.loadMore') }}
          </f7-button>
        </div>
      </div>
    </f7-popup>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';
import { useParamRef } from '@erpagroapp/params';

import ConexionTA from '@/js/services/traceability/APITraceability';
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import SoporteFechaYHora from '@/js/common/HIConversionSupport';
import SoporteNumeracion from '@/js/common/HiNumerationSupport';
import SoportePersonalizacion from '@/js/services/soportePersonalizacion';
import SoporteCadena from '@/js/common/HiChainSupport';
import UCPreload from '@/components/common/UCPreload.vue';
import {
  HiNotification,
} from '@/js/common/HINotificationSupport';
import PCOperacionesPersonalizadas from './PCOperacionesPersonalizadas.vue';

export default {
  name: 'PCPartidasActivasYRecientesLineaParaPaletizado',
  components: {
    UCPreload,
    PCOperacionesPersonalizadas,
  },
  props: {
    intervaloActualizacionAutomatica: {
      type: Number,
      default: 0,
    },
    envasadosLineaProduccion: {
      type: Array,
      default: () => [],
    }, // Contiene un array que permite realizar los calculos de kilos envasados vs kilos volcados por partida.
    puntoPaletizadoSeleccionado: { type: Object, default: null }, // Si se establece un punto se filtraran por los puntos de volcado asociados a cada punto de paletizado.
  },

  emits: ['seleccionPartida'],

  data() {
    return {
      lineaProduccion: null,
      mostrarPrecarga: false, // Muestra el componente de carga del resumen.
      mostrarPrecargaVerMas: false, // Muestra la precarga del ver más.
      partidasEnPuntoDeVolcado: null,
      seleccionPatidaEnPuntoDevolcado: null, // Contiene el elemento partidaEnPuntoDeVolcado Seleccionado.
      kilosVolcadosPartidaSeleccionada: 0,
      kilosEnvasadosPartidaSeleccionada: 0,
      kilosRestantesEnvasadoPartidaSeleccionada: 0,
      listadoPartidasTotalesEnPuntoVolcado: null, // Carga el listado de las X ultimas partidas cuando se pulsa en Ver Más.
      popupMasPartidasVolcadas: false, // Controla la apertura del popup  que muestra mas partidas volcadas.

      /**
       * Mantiene el timer que realiza las actualizaciones automáticas.
       * @type {ReturnType<typeof setTimeout> | null}
       */
      actualizadorAutomatico: null,

      indiceDelFocoPartida: 0, // Mantiene la posición de la partida seleccionada.
      cantidadRegistrosCargaVistaPopup: 50, // Cantidad de registro que carga en la vista de ver más.
      personalizacionComponentePartidasActiva: false, // Controla si esta activa la visualización de personalizaciones en el componente.
      datosPartidasParaPersonalizaciones: [], // Mantiene la lista de personalizaciones cargadas de forma múltiple
      usoLotesMovilidad: useParamRef('UsoLotesMovilidad'),
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'lineaDeProduccionSeleccionada',
    ]),

    appTheme() {
      return {
        '--f7-navbar-text-color': '#fff',
      };
    },
  },
  watch: {
    envasadosLineaProduccion() {
      this.RecalculosKilosPartidaSeleccionada();
    },
    puntoPaletizadoSeleccionado() {
      this.RestablecerValores();
      this.ActualizarDatos();
    },
    partidasEnPuntoDeVolcado(val) {
      if (val !== null && val.length > 0) {
        this.ObtenerPersonalizacionesPartidas(val); // Carga de personalizacion
      }
    },
  },
  created() {
    this.InicializarComponente();
  },
  unmounted() {
    this.EliminarIntervaloActualizacionesAutomaticas();
  },
  methods: {
    InicializarComponente() {
      Log(this, this.InicializarComponente.name);
      if (this.intervaloActualizacionAutomatica > 0) {
        this.ProgramarIntervaloActualizacionesAutomaticas();
      }

      this.ConfigurarPersonalizacionesComponente();
    },

    ConfigurarPersonalizacionesComponente() {
      Log(this, this.ConfigurarPersonalizacionesComponente.name);
      this.personalizacionComponentePartidasActiva = SoportePersonalizacion.ExistePersonalizacion('FrmPaletizadoMultiPunto', 'PCPartidasActivasYRecientesLineaParaPaletizado');
    },

    /**
     * @public
     * @returns {void}
     */
    ActualizarDatos(mostrarPrecarga) {
      Log(this, this.ActualizarDatos.name);
      this.ObtenerLineaDeProduccionSeleccionada();
      if (this.lineaProduccion != null) {
        const self = this;
        self.mostrarPrecarga = mostrarPrecarga !== undefined ? mostrarPrecarga : true;
        // self.seleccionPatidaEnPuntoDevolcado = null;
        // self.partidasEnPuntoDeVolcado = [];
        // Filtramos por volcados solo de los puntos de volcado asociados al punto paletizado seleccionado.

        if (this.puntoPaletizadoSeleccionado != null) {
          this.ObtenerPartidasRecientesDeLaColaDeVolcadoXPuntoPaletizado(20).then((result) => {
            self.partidasEnPuntoDeVolcado = result;
            self.EstablecerElementoSeleccionado();
            self.mostrarPrecarga = false;
          }).catch((error) => {
            self.mostrarPrecarga = false;
            HiNotification.Toast(error);
          });
        } else {
          // Filtramos todos los volcados de los puntos de volcado de la linea seleccionada.
          this.ObtenerPartidasRecientesDeLaColaDeVolcado(20).then((result) => {
            self.partidasEnPuntoDeVolcado = result;
            self.EstablecerElementoSeleccionado();
            self.mostrarPrecarga = false;
          }).catch((error) => {
            self.mostrarPrecarga = false;
            HiNotification.Toast(error);
          });
        }
      }
    },

    /**
     * @public
     * @returns {void}
     */
    RestablecerValores() {
      Log(this, this.RestablecerValores.name);
      this.partidasEnPuntoDeVolcado = null;
      this.seleccionPatidaEnPuntoDevolcado = null;
      this.indiceDelFocoPartida = 0;
    },

    ObtenerLineaDeProduccionSeleccionada() {
      Log(this, this.ObtenerLineaDeProduccionSeleccionada.name);
      this.lineaProduccion = { ...this.lineaDeProduccionSeleccionada };
    },

    FormatearFecha(fechaYHora) {
      Log(this, this.FormatearFecha.name);
      return SoporteFechaYHora.obtenerHorasYMinutos(fechaYHora);
    },

    FormatearFecha2(fechaYHora) {
      Log(this, this.FormatearFecha2.name);
      return SoporteFechaYHora.ObtenerDiaMesAno(fechaYHora);
    },

    FormatearCadena(cadena, longitudMaxima) {
      Log(this, this.FormatearCadena.name);
      return SoporteCadena.TextoLogitudMaxima(cadena, longitudMaxima);
    },

    FormatearIdentificadorPartida(identificadorPartida) {
      Log(this, this.FormatearIdentificadorPartida.name);
      return SoporteNumeracion.EstablecerLogitudFija(identificadorPartida, 7);
    },

    /**
     * @public
     * @returns {void}
     */
    VerMasPartidasDeLaColaDeVolcado(cantidadRegistrosCarga) {
      Log(this, this.VerMasPartidasDeLaColaDeVolcado.name);
      // En caso de no venir definido cargamos 50 registros.
      if (cantidadRegistrosCarga == null || undefined) {
        this.cantidadRegistrosCargaVistaPopup = 50;
        this.mostrarPrecargaVerMas = true; // Solo mostramos la precarca total en el caso de que la carga es la inicial, en los cargar más no se muestra
      } else {
        this.cantidadRegistrosCargaVistaPopup = cantidadRegistrosCarga;
      }
      this.popupMasPartidasVolcadas = true;
      const self = this;

      // Filtramos por volcados solo de los puntos de volcado asociados al punto paletizado seleccionado.
      if (this.puntoPaletizadoSeleccionado != null) {
        this.ObtenerPartidasRecientesDeLaColaDeVolcadoXPuntoPaletizado(20).then((result) => {
          self.listadoPartidasTotalesEnPuntoVolcado = result;
          self.mostrarPrecargaVerMas = false;
        }).catch((error) => {
          self.mostrarPrecargaVerMas = false;
          HiNotification.Toast(error);
        });
      } else {
        // Filtramos todos los volcados de los puntos de volcado de la linea seleccionada.
        this.ObtenerPartidasRecientesDeLaColaDeVolcado(this.cantidadRegistrosCargaVistaPopup).then((result) => {
          self.listadoPartidasTotalesEnPuntoVolcado = result;
          self.mostrarPrecargaVerMas = false;
        }).catch((error) => {
          self.mostrarPrecargaVerMas = false;
          HiNotification.Toast(error);
        });
      }
    },

    CerrarMasPartidasVolcadas() {
      Log(this, this.CerrarMasPartidasVolcadas.name);
      this.popupMasPartidasVolcadas = false;
      this.listadoPartidasTotalesEnPuntoVolcado = null;
    },

    ProgramarIntervaloActualizacionesAutomaticas() {
      Log(this, this.ProgramarIntervaloActualizacionesAutomaticas.name);
      const self = this;
      this.actualizadorAutomatico = setInterval(() => {
        if (this.lineaProduccion != null) {
          self.ActualizarDatos(false);
          /*
          self.ObtenerPartidasRecientesDeLaColaDeVolcado(2).then((result) => {
            Log(this,'PCPartidasActivasYRecientesLineaParaPaletizado->Actualización automatica de Partidas Realizada');
            self.partidasEnPuntoDeVolcado = result;
            self.EstablecerElementoSeleccionado();
          });
          */
        }
      }, this.intervaloActualizacionAutomatica * 1000);
    },

    EstablecerElementoSeleccionado() {
      Log(this, this.EstablecerElementoSeleccionado.name);
      try {
        let tempPartidaSeleccionada = null;
        if (this.seleccionPatidaEnPuntoDevolcado != null && this.seleccionPatidaEnPuntoDevolcado !== undefined) {
          this.indiceDelFocoPartida = this.partidasEnPuntoDeVolcado.findIndex((p) => p.Partida.Id === this.seleccionPatidaEnPuntoDevolcado.Partida.Id);
          tempPartidaSeleccionada = this.partidasEnPuntoDeVolcado[this.indiceDelFocoPartida];
        } else {
          tempPartidaSeleccionada = this.partidasEnPuntoDeVolcado[this.indiceDelFocoPartida];
        }

        if (tempPartidaSeleccionada != null && tempPartidaSeleccionada !== undefined) {
          this.SeleccionPartida(tempPartidaSeleccionada);
        }
      } catch {
        Log(this, this.EstablecerElementoSeleccionado.name);
      }
    },

    EliminarIntervaloActualizacionesAutomaticas() {
      Log(this, this.EliminarIntervaloActualizacionesAutomaticas.name);
      if (this.actualizadorAutomatico) {
        clearInterval(this.actualizadorAutomatico);
      }
    },

    SeleccionPartida(partidaPVSeleccionada) {
      const self = this;
      Log(this, this.SeleccionPartida.name);
      this.seleccionPatidaEnPuntoDevolcado = partidaPVSeleccionada;

      // Obtenemos la partida seleccionada.
      let index = 0;
      this.partidasEnPuntoDeVolcado.forEach((element) => {
        const tempPartida = element.Partida;
        if (tempPartida.Id === partidaPVSeleccionada.Partida.Id) {
          self.indiceDelFocoPartida = index;
        }
        index += 1;
      });

      this.RestablecerContadoResDePartidaSeleccionada();
      this.RecalculosKilosPartidaSeleccionada();
      this.$emit('seleccionPartida', partidaPVSeleccionada);
    },
    /** Método SeleccionPartida  */
    RestablecerContadoResDePartidaSeleccionada() {
      Log(this, this.RestablecerContadoResDePartidaSeleccionada.name);
      this.kilosVolcadosPartidaSeleccionada = 0;
      this.kilosRestantesEnvasadoPartidaSeleccionada = 0;
      this.kilosRestantesEnvasadoPartidaSeleccionada = 0;
    },
    /** Método SeleccionPartida  */
    RecalculosKilosPartidaSeleccionada() {
      Log(this, this.RecalculosKilosPartidaSeleccionada.name);
      const self = this;
      if (this.seleccionPatidaEnPuntoDevolcado == null) {
        return;
      }
      this.kilosVolcadosPartidaSeleccionada = Number.parseInt(this.seleccionPatidaEnPuntoDevolcado.PesoVolcado, 10);
      this.kilosRestantesEnvasadoPartidaSeleccionada = (Number.parseInt(this.seleccionPatidaEnPuntoDevolcado.PesoVolcado, 10) - Number.parseInt(this.seleccionPatidaEnPuntoDevolcado.CantidadConfeccionada, 10)) * -1;
      this.kilosEnvasadosPartidaSeleccionada = Number.parseInt(this.seleccionPatidaEnPuntoDevolcado.CantidadConfeccionada, 10);

      if (this.envasadosLineaProduccion != null) {
        const tempEnvasadosPartidaSeleccionada = this.envasadosLineaProduccion.filter((e) => e.Partida.Id === this.seleccionPatidaEnPuntoDevolcado.Partida.Id);

        this.kilosEnvasadosPartidaSeleccionada = Number.parseInt(this.seleccionPatidaEnPuntoDevolcado.CantidadConfeccionada, 10);
        this.kilosRestantesEnvasadoPartidaSeleccionada = (Number.parseInt(this.seleccionPatidaEnPuntoDevolcado.PesoVolcado, 10) - Number.parseInt(this.seleccionPatidaEnPuntoDevolcado.CantidadConfeccionada, 10)) * -1;
        tempEnvasadosPartidaSeleccionada.forEach((envasado) => {
          // Sumamos solo los envadados que no vienen de un retrabajo, los retrabajados ya estan descontados en el total de la partida.
          if (envasado.MovimientoDeRetrabajo === false) {
            self.kilosEnvasadosPartidaSeleccionada = Number.parseInt(self.kilosEnvasadosPartidaSeleccionada, 10) + Number.parseInt(envasado.CantidadKilos, 10);
            self.kilosRestantesEnvasadoPartidaSeleccionada = Number.parseInt(self.kilosRestantesEnvasadoPartidaSeleccionada, 10) + Number.parseInt(envasado.CantidadKilos, 10);
          }
        });
      }
    },

    async ObtenerPersonalizacionesPartidas(lstPartidas) {
      Log(this, this.ObtenerPersonalizacionesPartidas.name);
      if (!this.personalizacionComponentePartidasActiva) {
        return;
      } // Comprueba si esta activa.
      this.datosPartidasParaPersonalizaciones = [];
      const entidades = [];
      lstPartidas.forEach((e) => {
        entidades.push({ Id: e.Partida.Id });
      });
      this.datosPartidasParaPersonalizaciones = await SoportePersonalizacion.ObtenerOperacionesPersonalizadasEntidadMultiple(entidades, 1, 'FrmPaletizadoMultiPunto', 'PCPartidasActivasYRecientesLineaParaPaletizado');
    },

    ObtenerPartidasRecientesDeLaColaDeVolcado(cantidadPartidasFinalizadasRecuperar) {
      Log(this, this.ObtenerPartidasRecientesDeLaColaDeVolcado.name);

      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerUltimasPartidasVolcadasConInformacionDeKilosDisponibles(this.lineaProduccion.Id, cantidadPartidasFinalizadasRecuperar).then((result) => {
          if (result.Valor) {
            resolve(JSON.parse(result.Mensaje));
          } else {
            reject(result.Mensaje);
          }
        })
          .catch((error) => {
            LogError(this, this.ObtenerPartidasRecientesDeLaColaDeVolcado.name, error);
            reject(error);
          });
      });
    },

    ObtenerPartidasRecientesDeLaColaDeVolcadoXPuntoPaletizado(cantidadPartidasFinalizadasRecuperar) {
      Log(this, this.ObtenerPartidasRecientesDeLaColaDeVolcadoXPuntoPaletizado.name);

      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerUltimasPartidasVolcadasXPuntoPaletizadoConInformacionDeKilosDisponibles(this.puntoPaletizadoSeleccionado.Id, cantidadPartidasFinalizadasRecuperar).then((result) => {
          if (result.Valor) {
            resolve(JSON.parse(result.Mensaje));
          } else {
            reject(result.Mensaje);
          }
        })
          .catch((error) => {
            LogError(this, this.ObtenerPartidasRecientesDeLaColaDeVolcadoXPuntoPaletizado.name, error);
            reject(error);
          });
      });
    },
  },
};
</script>

<style lang="scss">
.main-PCPartidasActivasYRecientesLineaParaPaletizado {
  .div-registrosDePartidasActivas {
    background: #fff;
  }
}

.col-horaVolcadoPartida {
  text-align: -webkit-right;
  margin-right: 5px;
}

.div-registroPartida {
  padding-top: 8px;
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 5px;
  display: flex;
  align-items: flex-start;
  border-bottom: 1px solid var(--his-disabled);

  .col-indicadorEstadoVolcado {
    padding-top: none;
    padding-right: 10px;
  }
}

.div-registrosDePartidasFinalizadas {
  background: #fafbfc;
}

.row-inidicadoresDeVolcadoEnvasado {
  padding-left: 20px;
  width: 100%;
}

.col-indicadorKilosEnvasados {
  text-align: -webkit-center;
}

.col-indicadorKilosVolcados {
  text-align: -webkit-right;
}

.div-registroPartidaSeleccionada {
  background: antiquewhite;
}

.div-registrosDePartidasPopup {
  overflow-y: auto;
  height: 63vh;
}

.btn-cargarMasPartidas {
  margin-top: 10px;
}
</style>
